<template>
    <div class="registered">
        <!-- 头部 -->
        <div class="registered-top">
            <img src="../../assets/img/login/logo-h.png" alt="" />
            <p @click="toHome">返回首页<span></span></p>
        </div>
        <!-- 注册主体 -->
        <div class="registered-body">
            <div class="registered-con">
                <div class="registered-form">
                    <h2>维护大师产品免责声明</h2>
                    <p>
                        本免责声明（以下简称“本声明”）适用于杭州云智互联科技有限公司（以下简称“云智互联”）研发的维护大师系列软件产品
                        （以下简称“维护大师”或“本产品”）及其所有功能模块，在您阅读本声明后若不同意此声明中的任何条款，或对
                        本声明存在质疑，请立刻停止使用我们的软件。若您已经开始或正在使用维护大师，则表示您已阅读并同意本
                        声明的所有条款之约定。
                    </p>
                    <p>
                        1.总则：您通过安装维护大师并使用维护大师提供的功能和服务，即表示您已经与云智互联签订使用本产品的协议并
                        立即生效。代表您已经同意本声明和同意维护大师的使用条款（“使用条款”公布在维护大师官网，云智互联有权更改
                        “使用条款”，经修订的“使用条款”一经在官方网站上公布后，立即自动生效）。
                    </p>
                    <p>
                        2.维护大师分免费功能和收费功能（收费功能发布前会在维护大师官网介绍），维护大师产品的软件著作权归云智互联所有，受国家法律保护。
                    </p>
                    <p>
                        3.维护大师经过详细的测试，但不能保证与所有的软硬件系统完全兼容，不能保证本产品完全没有错误。
                        如果出现不兼容及软件错误的情况，您可联系维护大师技术支持将情况报告给云智互联，获得技术支持。
                        如果无法解决兼容性问题，您可以卸载并删除本产品 。
                    </p>
                    <p>
                        4.由于本产品可以通过网络等途径下载、传播，对于从非维护大师官网下载的本产品以及从非维护大师发行的介质上获得的本产品，
                        云智互联无法保证该软件是否感染计算机病毒、是否隐藏有伪装的特洛伊木马程序或者黑客软件等问题，云智互联不承担由此引起的直接和间接损害责任。
                    </p>
                    <p>
                        5.使用本产品风险由您自行承担，在适用法律允许的最大范围内，对因使用或不能使用本产品所产生的损害及风险，
                        包括但不限于直接或间接的个人损害、他人损害、商业赢利的丧失、贸易中断、商业信息的丢失或任何其它经济损失，云智互联不承担任何责任。
                    </p>
                    <p>
                        6.云智互联不担保所提供的本产品的功能及服务一定能满足您的要求，也不担保服务不会中断，对服务的及时性、安全性、真实性、准确性都不作担保。
                    </p>
                    <p>
                        7.任何组织或个人在网络上发布，传播本产品的行为都是允许的，但因组织或个人传播本产品造成的任何法律和刑事事件云智互联不承担任何责任。
                    </p>
                    <p>
                        8.任何组织或个人不得在未经云智互联授权的情况下对本产品进行二次开发，功能修改和反编译。
                    </p>
                    <h2>维护大师-安全中心功能免责声明</h2>
                    <p>
                        1.
                        维护大师安全中心功能（以下简称“本功能”）属于杭州云智互联科技有限公司（以下简称“云智互联”）旗下产品维护大师产品的一个功能。
                        维护大师产品免责声明中的所有条款都适用于本功能的免责声明，请您先仔细阅读维护大师产品免责声明。
                    </p>
                    <p>
                        2.
                        本功能作为一个主动防御系统，维护大师系列产品（以下简称“维护大师”）及本功能自身不具有任何拦截功能，
                        单独运行维护大师及本功能不会拦截任何广告、病毒程序等。您编写并使用相关拦截规则，才会开始生效。
                        您可以根据自己的实际需要，选择是否使用这些规则。对于使用维护大师及本功能，造成对其他商业软件的侵权行为，
                        由使用者自行承担，云智互联不承担任何法律责任。
                    </p>
                    <p>
                        3.
                        本功能是主动防御型软件，故包含拦截、监视、删除、结束等功能。具体做什么操作由您决定，您添加相关规则即可开启对应功能。
                        维护大师及本功能只能用于合法的目的，您有责任确保您使用维护大师及本功能符合任何相关的法律、法规、条例、规则、规章，
                        否则因此造成的任何纠纷、损失、责任都由您承担，云智互联不承担损失、任何责任。
                    </p>
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <div class="registered-footer">
            &reg; 2014-2018 杭州云智互联科技有限公司
        </div>
    </div>
</template>

<script>
export default {
    name: "register",
    methods: {
        toHome() {
            window.location.href = "/";
        }
    }
};
</script>

<style lang="scss">
.registered {
    width: 100%;
    height: 100vh;
    min-height: 920px;
    background-color: #f5f5f6;
    background-size: cover;
    background-position: center;
    position: relative;
    // 头部
    .registered-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 60px;
        background-color: #f5f5f6;
        border-bottom: 1px solid #d7d8d9;
        img {
            margin-left: 30px;
            width: 124px;
            height: 30px;
        }
        p {
            margin-right: 20px;
            font-size: 15px;
            color: #383d41;
            font-weight: bold;
            cursor: pointer;
            span {
                display: block;
                float: right;
                margin-top: 4px;
                margin-left: 5px;
                width: 12px;
                height: 12px;
                background: url(../../assets/img/icon/箭头.png);
            }
        }
        p:hover {
            color: #00c2de;
        }
    }
    // 注册主体
    .registered-body {
        display: flex;
        justify-content: center;
        width: 100%;
        background-size: 90% 100%;
        background-position: center bottom;
        .registered-con {
            display: flex;
            justify-content: center;
            margin-top: 20px;
            padding-bottom: 10px;
            width: 1000px;
            // height: 650px;
            background-color: #fff;
        }
        .registered-form {
            width: 80%;
            // height: 200px;
            text-align: left;
            h2 {
                font-size: 16px;
                line-height: 50px;
                text-align: center;
                font-weight: bold;
            }
            p {
                margin-bottom: 5px;
                font-size: 14px;
                text-indent: 28px;
                line-height: 20px;
            }
        }
    }
    // 底部
    .registered-footer {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 60px;
        background-color: #383d41;
        color: #84878c;
        text-align: center;
        line-height: 60px;
        font-size: 16px;
    }
}
</style>
